import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { stateCleanup } from '../../store/actions/AuthActions';
import styles from './TestComplete.scss';
import success_top from '../../assets/images/testcomplete/success-top.png';
import success_bot_r from '../../assets/images/testcomplete/success-bot-r.png';
import success_bot_l from '../../assets/images/testcomplete/success-bot-l.png';
//allows the user to change language
class TestComplete extends Component {
  componentDidUnmount() {
    this.props.stateCleanup();
  }

  render() {
    const testTitle = this.props.testTitle || sessionStorage.getItem('test_title');

    // testTitle is dynamic (data), so it should not be translated.
    // If it's missing for some reason, render an empty string.
    const safeTestTitle = testTitle || '';

    const companyName = this.props.companyName || sessionStorage.getItem('company_name');

    return (
      <div className={styles['c-msg-box']}>
        <div className={styles['c-msg-box__top-image']}>
          <img
            src={success_top}
            alt="success-top"
          />
        </div>

        <h2 className="sub-header-font-size-mid bold">{safeTestTitle}</h2>

        <p>
          {this.props.t('test_complete.submitted_message')}
          <br />
          {this.props.t('test_complete.company_received', {
            company: companyName,
          })}
        </p>

        <div className={styles['c-msg-box__bottom-image']}>
          <img
            className={styles['c-msg-box__bottom-image-left']}
            src={success_bot_l}
            alt="success-bot-r"
          />
          <img
            className={styles['c-msg-box__bottom-image-right']}
            src={success_bot_r}
            alt="success-bot-l"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    testTitle: state.assessment.testInfo.title,
    companyName: state.auth.company_details.name,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    stateCleanup: () => dispatch(stateCleanup()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('modal')(TestComplete));
